import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ListadoVehiculos from './pages/ListadoVehiculos/ListadoVehiculos';
import EditarVehiculo from './pages/EditarVehiculo/EditarVehiculo';

const ZeroRoutes = ({ ProtectedRouteLogin, HomePublicaLayout, userIsLoggedIn }) => {
  return (
    <Switch>
      <ProtectedRouteLogin
        exact={true}
        path='/zero/vehiculos'
        loggedIn={userIsLoggedIn}
        component={ListadoVehiculos}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        exact={true}
        path='/zero/vehiculos/crear'
        loggedIn={userIsLoggedIn}
        component={EditarVehiculo}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
      <ProtectedRouteLogin
        exact={true}
        path='/zero/vehiculos/editar/:id'
        loggedIn={userIsLoggedIn}
        component={EditarVehiculo}
        layout={HomePublicaLayout}
        pathredirect={"/login"}
        carritovisible={false}
      />
    </Switch>
  );
};

export default ZeroRoutes;
